import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { refreshAccessToken } from '../api/auth/authApi';
import {
  clearAuthSession,
  hasAppAccess,
  isAuthenticated,
  isGuestMode,
  isTokenExpired,
} from '../api/auth/authStorage';
import { syncAppSettingsFromServer } from '../api/users/appSettingsStorage';

export default function ProtectedRoute({ children, guestAllowed = true }) {
  const location = useLocation();
  const shouldRefresh = isAuthenticated() && isTokenExpired();
  const [status, setStatus] = useState(shouldRefresh ? 'refreshing' : 'ready');

  useEffect(() => {
    if (status !== 'refreshing') return;

    let cancelled = false;
    refreshAccessToken()
      .then(() => {
        if (!cancelled) setStatus('ready');
      })
      .catch(() => {
        if (!cancelled) {
          clearAuthSession();
          setStatus('failed');
        }
      });

    return () => {
      cancelled = true;
    };
  }, [status]);

  useEffect(() => {
    if (status !== 'ready' || !isAuthenticated() || isGuestMode()) return;
    syncAppSettingsFromServer().catch((error) => {
      console.warn('[ProtectedRoute] syncAppSettingsFromServer:', error);
    });
  }, [status]);

  if (!hasAppAccess() || status === 'failed') {
    return <Navigate to="/login-menu" replace />;
  }

  if (!guestAllowed && isGuestMode()) {
    return <Navigate to="/tylko-dla-zalogowanych" state={{ from: location.pathname }} replace />;
  }

  if (status === 'refreshing') {
    return null;
  }

  return children;
}
